import React, { useContext, useEffect, useState } from "react";
import "../../../assets/css/user/supportDisputes/SupportDisputes.css";
import axios from "axios";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import AppContext from "../../../context/AppContext";
import { FaArrowLeft } from "react-icons/fa";
import MarqueeBanner from "../../../components/user/Marqueebanner/Marqueebanner";
import Navbar from "../../../components/user/navbar/Navbar";
import { Container } from "react-bootstrap";
import SimpleBanner from "../../../components/user/general/SimpleBanner";

export default function SupportDisputes() {
  const navigate = useNavigate();
  const { baseUrl } = useContext(AppContext);
  const location = useLocation();

  console.log("Location State:", location.state);

  const order = location.state?.order;

  console.log("Order:", order);

  const loggedInUser = JSON.parse(localStorage.getItem("loggedInUser"));

  console.log("LocalStorage User:", loggedInUser);

  // ================= STATE =================
  const [title, setTitle] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);
  const [orderId, setOrderId] = useState("");
  const [tpshopId, tpsetshopId] = useState("");
  const [type, setType] = useState("Order Dispute (goes to seller)");
  const [description, setDescription] = useState("");
  const [tickets, setTickets] = useState([]);

  // ================= CREATE TICKET =================
  const submitTicket = (e) => {
    e.preventDefault();

    if (!loggedInUser?.id) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Customer not found",
      });
      return;
    }

    setSubmitLoading(true);

    const formData = new FormData();

    formData.append("title", title);
    formData.append("description", description);
    formData.append("type", type);
    formData.append("order_id", orderId);
    formData.append("tpshop_id", tpshopId);

    formData.append("generated_by", "customer");

    formData.append("tpcustomer_id", loggedInUser.id);

    axios
      .post(`${baseUrl}/customer/support/createTicket`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        console.log(response.data);

        setSubmitLoading(false);

        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Ticket submitted successfully",
        });

        // reset form
        setTitle("");
        setOrderId("");
        setDescription("");
        setType("Order Dispute (goes to seller)");

        viewMyTickets();
      })
      .catch((err) => {
        console.log(err);

        setSubmitLoading(false);

        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to submit ticket",
        });
      });
  };

  // ================= FETCH TICKETS =================
  const viewMyTickets = () => {
    if (!loggedInUser?.id) return;

    const formData = new FormData();

    formData.append("tpcustomer_id", loggedInUser.id);

    axios
      .post(`${baseUrl}/customer/support/viewMyTickets`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        console.log("Customer Tickets", response.data.tickets);

        setTickets(response.data.tickets);
      })
      .catch((err) => {
        console.log(err.response.data);

        Swal.fire({
          icon: "error",
          title: "Error",
          text: err.response.data.error,
        });

        setSubmitLoading(false);
      });
  };

  // ================= USE EFFECT =================
  useEffect(() => {
    if (order) {
      setOrderId(order.id);

      tpsetshopId(order.tpshop_id);
    }
    console.log("Context User:", loggedInUser);
    console.log("LocalStorage:", localStorage.getItem("loggedInUser"));
    viewMyTickets();
  }, [order]);

  return (
    <Container fluid>
      <MarqueeBanner />
      <Navbar />

      <div className="sd-page">
        <div className="sd-header">
          <div className="d-flex align-items-center gap-3">
            <FaArrowLeft
              className="back-icon"
              onClick={() => navigate("/customer-orders")}
            />

            <h1 className="sd-title mb-0">Support & Disputes</h1>
          </div>

          <p className="sd-subtitle">Raise an issue against an order.</p>
        </div>

        {/* FORM */}
        <div className="sd-card">
          <h2 className="sd-card-title">Raise a New Issue</h2>

          <form className="sd-form" onSubmit={submitTicket}>
            <div className="sd-field">
              <label className="sd-label">Title</label>

              <input
                className="sd-input"
                type="text"
                placeholder="What do you need help with?"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>

            <div className="sd-row">
              <div className="sd-field">
                <label className="sd-label">Order ID</label>

                <input className="sd-input" value={orderId} readOnly />
              </div>

              <div className="sd-field">
                <label className="sd-label">Issue Type</label>

                <select
                  className="sd-select"
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                >
                  <option>Order Dispute (goes to seller)</option>

                  <option>General Query (goes to admin)</option>

                  <option>Refund Request</option>

                  <option>Technical Issue</option>
                </select>
              </div>
            </div>

            <div className="sd-field">
              <label className="sd-label">Description</label>

              <textarea
                className="sd-textarea"
                placeholder="Describe your issue..."
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>

            <button
              className="sd-submit-btn"
              type="submit"
              disabled={submitLoading}
            >
              {submitLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                  ></span>
                  Submitting...
                </>
              ) : (
                <>+ Submit Ticket</>
              )}
            </button>
          </form>
        </div>

        {/* MY TICKETS */}
        <div className="sd-card">
          <h2 className="sd-card-title">My Tickets</h2>

          <div className="sd-table-wrapper">
            <table className="sd-table">
              <thead>
                <tr>
                  <th>Ticket ID</th>
                  <th>Title</th>
                  <th>Description</th>
                  <th>Status</th>
                  <th>Date</th>
                  <th>Chat</th>
                </tr>
              </thead>

              <tbody>
                {tickets.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No Tickets Found
                    </td>
                  </tr>
                ) : (
                  tickets.map((ticket) => (
                    <tr key={ticket.id}>
                      <td>{ticket.id}</td>

                      <td>{ticket.title}</td>

                      <td>{ticket.description}</td>

                      <td>{ticket.status}</td>

                      <td>{ticket.created_at}</td>
                      <td>
                        <button
                          className="sd-chat-btn"
                          title="Open chat"
                          onClick={() =>
                            navigate(`/customer-chat/${ticket.id}`)
                          }
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                          </svg>
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Container>
  );
}
